import styled, { css } from "styled-components";

const errorStyle = css`
  padding-left: 15px;
  border-left: 5px solid #d4351c;
`;
export const MarginLessFormGroup = styled.div`
  ${({ isValid = true }) => (isValid ? null : errorStyle)}
`;

MarginLessFormGroup.displayName = "MarginlessFormGroup";
